export class OfferCard extends HTMLElement {
    async connectedCallback() {
        //cdn test
        const isMobile = window.innerWidth < 1024;
        if (document.readyState !== 'complete') {
            window.addEventListener('load', () => this.init());
        } else {
            this.init();
        }

        let phoneShow = false;
        const phone = this.getAttribute('phone');
        this.addEventListener('click', (e) => {
            if (e.target.hasAttribute('navigation-jk-search' || e.target.closest('[navigation-jk-search]'))) {
                const customEvent = new CustomEvent('FIND_JK_LIST', {bubbles: true});
                const bankSuffix = window.cian_bank_id ? `&banks[0]=${window.cian_bank_id}` : "";
                const queryString = localStorage.getItem('jk-search-query-string') || '';
                customEvent.queryString = `${queryString}${bankSuffix}`;
                customEvent.newTab = !isMobile;
                console.log(customEvent)
                this.dispatchEvent(customEvent);
                e.stopPropagation();
            }
            if (e.target.hasAttribute('navigation-search' || e.target.closest('[navigation-search]'))) {
                const customEvent = new CustomEvent('FIND_LIST', {bubbles: true});
                customEvent.queryString = localStorage.getItem('search-query-string') || '';
                customEvent.newTab = !isMobile;
                console.log(customEvent)
                this.dispatchEvent(customEvent);
                e.stopPropagation();
            }
            const button = e.target.hasAttribute('cian-show-phone-button') ? e.target : e.target.closest('[cian-show-phone-button]');

            if (!phoneShow && button) {
                button.style.color = "#262C40";
                button.style.backgroundColor = "#E9F1F9";
                button.style.border = "solid 1px white";
                button.style.fontWeight = 'bold';
                button.style.fontSize = '16px';
                button.style.lineHeight = '20px';
                button.style.padding = "15px 14px 15px 14px";
                button.innerHTML = `<a href="tel: ${phone}" rel="nofollow" style="text-decoration:none">`
                // button.textContent = phone;
                phoneShow = true;
            }
        });

        ['OPEN_CALLBACK_POPUP', 'CLOSE_CALLBACK_POPUP'].forEach((event) => {
            document.addEventListener(event, this.removeSticky)
        });


        document.addEventListener('scroll', (e) => {
            const subHeader = document.getElementById('sticky-block-subheader-offer-card');
            const {target: {defaultView}} = e;
            if (defaultView.scrollY < 382) {
                subHeader.style.display = 'none';
            }
            if (defaultView.scrollY >= 382) {
                subHeader.style.display = 'block';
            }
            e.stopPropagation();
        })

        this.addEventListener('click', (e) => {
            if (e.target.hasAttribute('navigation-bank-main' || e.target.closest('[navigation-bank-main]'))) {
                this.dispatchEvent(new CustomEvent('GO_BANK_MAIN', {bubbles: true}))
            }
            if (e.target.hasAttribute('navigation-main' || e.target.closest('[navigation-main]'))) {
                this.dispatchEvent(new CustomEvent('GO_MAIN', {bubbles: true}))
            }
        })
        this.dispatchEvent(new CustomEvent('OFFER_LOADED', {
            bubbles: true,
            detail: {
                isNew: this.hasAttribute('new-building'),
                isComplete: this.hasAttribute('is-complete') ? JSON.parse(this.getAttribute('is-complete')) : true,
                totalPrice: Number.parseInt(this.getAttribute('total-price')),
                sqMeterPrice: Number.parseInt(this.getAttribute('sqm-price')),
                type: this.getAttribute('type'),
                region: this.getAttribute('sale-region'),
            }
        }));
    }
    disconnectedCallback() {
        document.removeEventListener('OPEN_CALLBACK_POPUP', this.removeSticky);
        document.removeEventListener('CLOSE_CALLBACK_POPUP', this.removeSticky);
    }
    removeSticky({type}) {
        const stickyElement = document.getElementById('sticky-element');
        if (type === 'OPEN_CALLBACK_POPUP') {
            stickyElement.style.position = 'relative';
        }
        if (type === 'CLOSE_CALLBACK_POPUP') {
            stickyElement.style.position = 'sticky';
        }
    }

    async init() {
        try {
            const isPartnerObject = this.isPartnerProgram();
            this.querySelector('mortgage-button').setAttribute('isPartnerObject', isPartnerObject)
            this.querySelector('call-tracking-button-light').setAttribute('isPartnerObject', isPartnerObject)
            console.log({isPartnerObject})
            const offerId = this.getAttribute('offer-id');
            const propertyType = this.getAttribute('property-type') || 'undefined';
            const regionId = this.getAttribute('region-id');
            const oblastId = this.getAttribute('oblast-id');
            let cianCdUser = localStorage.getItem('cianCdUser');
            let cianCdSession = sessionStorage.getItem('cianCdSession');
            let cianUserAbGroup = localStorage.getItem('cianUserAbGroup');
            const response = await fetch(
                'https://cd-business-events-collector.content.cian.ru/events/',
                {
                    credentials: "include",
                    method: 'POST',
                    body: JSON.stringify({
                        'serviceName': 'offer-card-desktop',
                        'eventType': 'visited',
                        'propertyType': propertyType,
                        'offerId': offerId,
                        'data': {
                            'isPartnerObject': isPartnerObject,
                            'regionId': regionId,
                            'oblastId': oblastId,
                            'cianCdUser': cianCdUser,
                            'cianCdSession': cianCdSession,
                            'cianUserAbGroup': cianUserAbGroup,
                            'pwa': !!window.sessionStorage && sessionStorage.getItem('pwa') === 'true'
                        }
                    }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    }
                });
            const responseData = await response.json();
            localStorage.setItem('cianCdUser', responseData.cianCdUser);
            sessionStorage.setItem('cianCdSession', responseData.cianCdSession);
            localStorage.setItem('cianUserAbGroup', responseData.cianUserAbGroup);
        } catch (e) {
            console.log('===============failed save visited===============')
        }

        const partnerProgramsString = localStorage.getItem('partner-programs');
        const partnerPrograms = !!partnerProgramsString && JSON.parse(partnerProgramsString);
        if (!!partnerPrograms) {
            const cianUserId = this.getAttribute('cian-user-id');
            const builderId = this.getAttribute('builder-id');
            const partnerProgram = partnerPrograms.find(p => (cianUserId && p.cian_user_id === cianUserId) || (builderId && p.builder_id === builderId));
            if (!!partnerProgram && !!this.querySelector('cian-finance-calculator')) {
                this.querySelector('cian-finance-calculator').setAttribute('partner-discount', partnerProgram.discount);
                this.querySelector('cian-finance-calculator').setAttribute('partner-base-rate', partnerProgram.base_rate);


            }
        }

        this.addEventListener('click', (e) => {
            const mortgageButton = e.target.hasAttribute('mortgage-button') ? e.target : e.target.closest('[mortgage-button]');
            if (mortgageButton) {
                const customEvent = new CustomEvent('FILL_ANKETA', {
                    bubbles: true,
                    detail: { component: 'offer-card' } // Этот параметр обрабатывается в customization для проставления utm меток в зависимости от компонента
                });
                this.dispatchEvent(customEvent);
                return;
            }
            const jkLink = e.target.hasAttribute('jk-ref') ? e.target : e.target.closest('[jk-ref]');
            if (jkLink) {
                const customEvent = new CustomEvent('SHOW_JK', {bubbles: true});
                customEvent.jkRef = jkLink.getAttribute('jk-ref');
                customEvent.newTab = true;
                this.dispatchEvent(customEvent);
                return;
            }
        });
    }

    isPartnerProgram = () => {
        const partnerProgramsString = localStorage.getItem('partner-programs');
        const partnerPrograms = !!partnerProgramsString && JSON.parse(partnerProgramsString);
        if (!!partnerPrograms) {
            const cianUserId = this.getAttribute('cian-user-id');
            const partnerProgram = partnerPrograms.find(p => p.cian_user_id === cianUserId);
            return !!partnerProgram
        } else return false;
    }
}

export class GoMap extends HTMLElement {
    connectedCallback() {
        this.addEventListener('click', (event) => {
            const mapBlock = document.getElementById('cian-offer-card-map-block');
            mapBlock.scrollIntoView({block: 'start', behavior: 'smooth'});
        })
    }
}
